import { render, staticRenderFns } from "./DetalleUsuarioRoles.vue?vue&type=template&id=79fa9240&"
import script from "./DetalleUsuarioRoles.vue?vue&type=script&lang=js&"
export * from "./DetalleUsuarioRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports